import React, { useContext, useEffect, useState } from 'react';
import { Checkbox, Modal, PrimaryButton, TextField } from '@fluentui/react';
import "../Styles/ShareStudyLinkCss.css";
import { shareStudyLinkApi, shareStudyToUsersApi } from '../../../../service/StudyListService';
import ModalHeader from '../../../../components/Modal/ModalHeader';
import ModalFooter from '../../../../components/Modal/ModalFooter';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { ShareStudyLinkSchema,createShareStudyLinkSchema  } from './ShareStudyLinkSchema';
import ShareStudyContext from '../../../../context/sharestudy/ShareStudyContext';
import ShareStudyLinkBody from './ShareStudyLinkBody';
import ModalMain from '../../../../components/Modal/ModalMain';
import userContext from '../../../../context/users/UserContext';
import { USERTYPES } from "../../../../constants/Constants";
import { getEnv } from '../../../../helpers/EnvHelper';

const ShareStudyLink = (props) => {
    const {roles, userId } = useContext(userContext);
    
    const { fetchShareStudyUrl, 
        studyShareUrl, 
        studyShareUrlPassword,  
        showShareStudyLinkModal, 
        setShowShareStudyLinkModal, 
        shareStudyByMail} = useContext(ShareStudyContext);

    const [t] = useTranslation();
    // const [studyShareEmail, setStudyShareEmail] = useState("");
    const [isEmailChecked, setIsEmailChecked] = useState(false);
    const [loadingState, setLoadingState] = useState("");
    const [loading, setLoading] = useState(false);
    // const [studyShareUrl, setStudyShareUrl] = useState("");

    const [visibleWhatsapp, setVisibleWhatsapp] = useState(false);
    const [isWhatsappChecked, setIsWhatsappChecked] = useState(false);
    const [whatsappEnabled, setWhatsappEnabled] = useState(false);
    const [emailEnabled, setEmailEnabled] = useState(false);

    // const getStudyUrl = () =>{
    //     fetchShareStudyUrl(props.studyId, props.firmId, props.clientId);
    // }
    const getStudyUrl = async () => {
    try {
      const data = await fetchShareStudyUrl(props.studyId, props.firmId, props.clientId);
      console.log("Sharestudylink :",data);
      if (data) {
        setEmailEnabled(data.emailEnabled);
        setWhatsappEnabled(data.whatsappEnabled);
      }
    } catch (err) {
      console.error("Error fetching share study URL:", err);
    }
    };

    useEffect(()=>{
        getStudyUrl();
    },[]);

    useEffect(() => {
        // Super Admin or Admin → always visible
        if (roles[0] === USERTYPES.ADMIN ) {
            setVisibleWhatsapp(true);
        }
        // Firm Admin → depends on firm flag
        else if (roles[0] === USERTYPES.FIRMADMIN) {
            setVisibleWhatsapp(whatsappEnabled);
        }
        // Everyone else → depends on user flag
        else {
            setVisibleWhatsapp(whatsappEnabled);
        }
    }, [roles, whatsappEnabled]);

    // ensure validationSchema is re-evaluated when checkbox flags change
    // useEffect(() => {
    // if (typeof validateForm === 'function') {
    //     validateForm();
    // }
    // }, [isEmailChecked, isWhatsappChecked]);


    const handleEmailcheck = () =>{
         if (!emailEnabled) return;
        if(isEmailChecked){
            setIsEmailChecked(false);
        }else{
            setIsEmailChecked(true);
        }
    }

    const handleClose = () =>{
        setShowShareStudyLinkModal(false);
        if( props.setShowShareStudyLinkModal != undefined){
            props.setShowShareStudyLinkModal(false);
        }
    }

    const handleDonePayload = (values) =>{
        return {
            mail: isEmailChecked?values.email:"",
            //whatsappNo:"",
            whatsappNo: isWhatsappChecked ? (values.whatsappNo || "").trim() : "",
            SMSNo:"",
            sharedUrl: values.studyShareUrl,
            mailChacked: isEmailChecked,
            smsChacked: false,
            whatsappChacked: isWhatsappChecked,
            studyId: props.studyId,
            firmId: props.firmId,
            clientId: props.clientId

        }
    }

      const {
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        validateForm , 
      } = useFormik({
        initialValues:  {
            studyShareUrl: studyShareUrl !=""?studyShareUrl:props.studyShareUrl,
            studyShareUrlPassword: studyShareUrlPassword!=""?studyShareUrlPassword:props.studyShareUrlPassword,
            email: "",
            whatsappNo: "" // <-- NEW: whatsapp 
        },
        enableReinitialize: true,
        //validationSchema: isEmailChecked === true ? ShareStudyLinkSchema : null,
        validationSchema: createShareStudyLinkSchema(isEmailChecked, isWhatsappChecked),
        // onSubmit: async (values) => {
        //     if(isEmailChecked){
        //         setLoadingState("Sending email");
        //         setLoading(true);
        //         const payload = handleDonePayload(values);

        //         if( props.setShowShareStudyLinkModal != undefined){
        //             props.setShowShareStudyLinkModal(false);
        //         }
        //         shareStudyByMail(payload);
        //         setLoading(false);
        //     }else{
        //         setShowShareStudyLinkModal(false);
        //         if( props.setShowShareStudyLinkModal != undefined){
        //             props.setShowShareStudyLinkModal(false);
        //         }
        //     }
        // }
        onSubmit: async (values) => {

            // Build payload from the form values and checkbox flags
            const payload = handleDonePayload(values);

            //  loading message
            setLoadingState(
            isEmailChecked && isWhatsappChecked ? "Sending..." :
            isEmailChecked ? "Sending email" : "Sending WhatsApp"
            );
            setLoading(true);

            // close modal early 
            if (props.setShowShareStudyLinkModal != undefined) {
                props.setShowShareStudyLinkModal(false);
            }

            try {
                await shareStudyByMail(payload); 
            } catch (e) {
                console.error("share error", e);
            } finally {
                setLoading(false);
            }
        }

        
      });
      // re-run validation when checkboxes change
        useEffect(() => {
        if (typeof validateForm === 'function') {
            validateForm();
        }
        }, [isEmailChecked, isWhatsappChecked, validateForm]);

        // Keep form state in-sync with channel availability
        useEffect(() => {
          // If email channel is disabled, uncheck and clear the email field
          if (!emailEnabled) {
            setIsEmailChecked(false);
            if (typeof setFieldValue === "function") {
              setFieldValue("email", "");
            }
          }

          // If whatsapp channel is not visible/allowed, uncheck and clear whatsapp field
          if (!visibleWhatsapp) {
            setIsWhatsappChecked(false);
            if (typeof setFieldValue === "function") {
              setFieldValue("whatsappNo", "");
            }
          }
        }, [emailEnabled, visibleWhatsapp, setFieldValue]);

        useEffect(() => {
          // If nothing is selected, force Email ON (only if allowed)
          if (!emailEnabled && !whatsappEnabled) {
            setEmailEnabled(true);
          }
        }, [emailEnabled, visibleWhatsapp]);




      let PrimaryButtonList = [
        {
            title:t("button.share"),
            onclick: handleSubmit,
            //disabled: !isEmailChecked
            disabled: !(isEmailChecked || isWhatsappChecked)
        }
    ];
    let DefaultButtonList = [
        {
            title:t("button.close"),
            onclick: handleClose
        }
    ];
    const contentStyles =  {
        root:{
          backgroundColor: 'rgb(22, 21, 20, 0.7)'
       },
    };

    const Containerstyles=  {
        root:{
          backgroundColor: 'rgb(22, 21, 20, 0.7)'
       },
        main:{
          boxSizing: "border-box",
          borderRadius: "10px 10px 10px 10px",
          fontFamily: "Open Sans",
          fontStyle: "normal",
          boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.90)",
          border: "1px solid #4B4B4B",
          width : "500px",
        },
        // modalBody:{
        //   padding: "20px",
        //   backgroundColor: "#191919",
        //   border:"1px solid white",
        // }
      }

    const modalDetails = {
        header: <ModalHeader updatedModal = {true} showPatientDetails={false} heading={t("share-study.title")} handleCancel={handleClose}/>,
        footer : <ModalFooter DefaultButtonList={DefaultButtonList} PrimaryButtonList={(getEnv("REACT_APP_ENABLE_EMAIL_ON_SHARE_STUDY") == "true" || getEnv("REACT_APP_ENABLE_EMAIL_ON_SHARE_STUDY") == true) ? PrimaryButtonList : []}/>,
        body : <ShareStudyLinkBody handleEmailcheck={handleEmailcheck} setIsEmailChecked={setIsEmailChecked} isEmailChecked={isEmailChecked} values={values} handleChange={handleChange} studyId="71" errors={errors}
                visibleWhatsapp={visibleWhatsapp}
                isWhatsappChecked={isWhatsappChecked}
                setIsWhatsappChecked={setIsWhatsappChecked}
                emailEnabled={emailEnabled}
                setFieldValue={setFieldValue}
                touched={touched}          
                handleBlur={handleBlur}
                />,
        width : "500px",
      }

  return (
    <>
        <ModalMain showModal={true} modalDetails={modalDetails}/>
    </>
  )
}

export default ShareStudyLink